/**
 * 资产管理模块翻译 - 中文
 * 包含：建筑物、楼层、铺位、广告位、共享空间、仓库、车位、可视化
 */
export default {
  asset: {
    // ==================== 通用 ====================
    visual: {
      editMode: '编辑模式',
      exitEdit: '退出编辑',
      drawAsset: '绘制资产',
      drawShop: '绘制铺位',
      selectShape: '选择形状',
      shapePrefix: '形状:',
      grid: '网格',
      gridSnap: '网格吸附',
      importBgSvg: '导入底图/SVG',
      importBg: '导入底图',
      clearFloor: '清除楼层',
      fullscreen: '全屏',
      exitFullscreen: '退出全屏',
      drawHint: '正在绘制 {type}，拖拽鼠标绘制，按 ESC 取消',
      polygonHint: '单击落点，双击或回车闭合，Esc 取消（至少3个顶点）',
      reOutline: '重新描边位置',
      noPositionTip: '该资产无位置信息，可在编辑模式下右键"重新描边位置"补画轮廓',
      reOutlineSuccess: '位置已更新',
      reOutlineFailed: '位置保存失败',
      polygonMinPoints: '多边形至少需要3个顶点',
      drawShopHint: '拖拽鼠标绘制铺位，按 ESC 取消',
      operationHint: '滚轮缩放 | Alt+拖拽平移 | 中键拖拽平移',
      typeFilter: '资产类型筛选',
      statusLegend: '状态图例',
      legend: '图例',
      properties: '属性',
      info: '信息',
      editDetail: '编辑详情',
      viewDetail: '查看详情',
      copy: '复制',
      shopProperties: '铺位属性',
      shopName: '资产名称',
      shopCode: '铺位编码',
      newShopName: '新铺位{n}',
      assetInfo: '资产信息',
      builtArea: '建筑面积',
      rentableAreaLabel: '计租面积',
      clearFloorConfirmMsg: '将清除当前楼层的所有资产和底图，此操作不可恢复，是否继续？',
      clearFloorConfirmTitle: '确认清除',
      clearFloorConfirmBtn: '确认清除',
      clearedCount: '已清除 {count} 个资产',
      clearFailed: '清除失败: {msg}',
      // 状态 map (tooltip)
      statusRented: '已出租',
      statusAvailable: '空置',
      statusReserved: '预留',
      statusMaintenance: '维修',
      // SVG底图确认
      confirmSvgBgTitle: '确认导入底图',
      confirmSvgBgWithShapes: '识别到 {count} 个资产形状，确定要将该SVG导入为底图吗？',
      confirmSvgBgNoShapes: '未识别到资产形状，确定要将该SVG导入为底图吗？',
      confirmSvgBgWithExisting: '当前楼层已有底图或资产，继续导入将清除现有内容，是否继续？',
    },
    // 形状
    shape: {
      rect: '矩形',
      circle: '圆形',
      ellipse: '椭圆',
      triangle: '三角形',
      diamond: '菱形',
      polygon: '多边形',
    },

    // ==================== SVG导入 ====================
    svgImport: {
      title: 'SVG楼层图导入',
      shapesFound: '识别到 {count} 个形状',
      unmatched: '未识别',
      ignored: '已忽略',
      totalArea: '总面积',
      preview: '预览',
      previewHint: '（编号与右侧列表对应，绿色=已匹配 橙色=待确认 灰色=忽略）',
      shapeList: '形状列表',
      setUnmatchedTo: '未识别设为:',
      select: '选择',
      ignore: '忽略',
      noId: '无ID',
      pendingConfirm: '待确认',
      nameLabel: '名称: ',
      codeLabel: '编码: ',
      areaPlaceholder: '面积',
      selectType: '选择类型',
      selectDept: '选择部门',
      batchDept: '批量设部门:',
      batchArea: '批量设面积:',
      apply: '应用',
      setAsBackground: '只导入底图',
      resetIgnored: '恢复已忽略',
      colorMapping: '按颜色定型:',
      applyColorMap: '应用颜色映射',
      colorMapEmpty: '请先为至少一种颜色选择资产类型',
      colorMapApplied: '已按颜色定型 {count} 个形状',
      autoIgnoredMsg: '已自动忽略 {count} 个疑似背景形状（小碎片/细长条），真铺位已排在列表顶部；如误判可点击列表头部"恢复已忽略"',
      confirmImport: '确认导入（{count}项）',
      confirmImportMsg: '将导入 {count} 个资产，当前楼层已有资产将被清除替换，是否继续？',
      confirmImportTitle: '确认导入',
      confirmImportBtn: '确认导入',
      // 识别来源
      sourceDataType: 'data-type属性',
      sourceId: 'ID前缀',
      sourceClass: 'class属性',
      sourceColor: '填充颜色',
      sourceUnknown: '无法自动识别',
    },

    // ==================== 广告位 ====================
    advertising: {
      editTitle: '编辑广告位',
      addTitle: '新增广告位',
      code: '广告位编码',
      name: '广告位名称',
      type: '广告位类型',
      displayType: '展示形式',
      widthMeter: '宽度(米)',
      heightMeter: '高度(米)',
      area: '建筑面积',
      rentableArea: '计租面积',
      monthlyFee: '月费用',
      managementDept: '管理部门',
      managementDeptPlaceholder: '请选择管理部门',
      managementDeptRequired: '管理部门不能为空',
      codePlaceholder: '请输入广告位编码',
      namePlaceholder: '请输入广告位名称',
      typePlaceholder: '请选择广告位类型',
      displayTypePlaceholder: '请选择展示形式',
      widthPlaceholder: '请输入宽度',
      heightPlaceholder: '请输入高度',
      areaPlaceholder: '请输入建筑面积',
      rentableAreaPlaceholder: '请输入计租面积',
      codeRequired: '请输入广告位编码',
      nameRequired: '请输入广告位名称',
      typeRequired: '请选择广告位类型',
      displayTypeRequired: '请选择展示形式',
      areaRequired: '建筑面积不能为空',
      rentableAreaRequired: '计租面积不能为空',
    },

    // ==================== 共享空间 ====================
    sharedSpace: {
      editTitle: '编辑共享空间',
      addTitle: '新增共享空间',
      code: '空间编码',
      name: '空间名称',
      type: '空间类型',
      areaUnit: '建筑面积',
      rentableArea: '计租面积',
      rentableAreaUnit: '计租面积',
      capacityUnit: '容量(人)',
      availableTime: '可用时段',
      managementDept: '管理部门',
      managementDeptPlaceholder: '请选择管理部门',
      managementDeptRequired: '管理部门不能为空',
      usageRestrictions: '使用限制',
      codePlaceholder: '请输入空间编码',
      namePlaceholder: '请输入空间名称',
      typePlaceholder: '请选择空间类型',
      areaPlaceholder: '请输入建筑面积',
      rentableAreaPlaceholder: '请输入计租面积',
      capacityPlaceholder: '请输入容量',
      availableTimePlaceholder: '如: 9:00-22:00',
      usagePlaceholder: '请输入使用限制说明',
      codeRequired: '请输入空间编码',
      nameRequired: '请输入空间名称',
      typeRequired: '请选择空间类型',
      areaRequired: '建筑面积不能为空',
      rentableAreaRequired: '计租面积不能为空',
      // 状态
      statusAvailable: '可用',
      statusReserved: '已预留',
      statusMaintenance: '维护中',
    },

    // ==================== 仓库 ====================
    warehouse: {
      editTitle: '编辑仓库',
      addTitle: '新增仓库',
      code: '仓库编码',
      name: '仓库名称',
      storageType: '存储类型',
      totalArea: '建筑面积',
      rentableArea: '计租面积',
      heightMeter: '层高(米)',
      loadCapacity: '载重(吨)',
      monthlyFeePerSqm: '月租金(元/㎡)',
      monthlyFeePlaceholder: '请输入月租金(元/㎡)',
      facilities: '设施配置',
      managementDept: '管理部门',
      managementDeptPlaceholder: '请选择管理部门',
      managementDeptRequired: '管理部门不能为空',
      ventilation: '通风',
      fireProtection: '消防',
      codePlaceholder: '请输入仓库编码',
      namePlaceholder: '请输入仓库名称',
      typePlaceholder: '请选择存储类型',
      totalAreaPlaceholder: '请输入建筑面积',
      rentableAreaPlaceholder: '请输入计租面积',
      heightPlaceholder: '请输入层高',
      loadCapacityPlaceholder: '请输入载重',
      codeRequired: '请输入仓库编码',
      nameRequired: '请输入仓库名称',
      typeRequired: '请选择存储类型',
      totalAreaRequired: '建筑面积不能为空',
      rentableAreaRequired: '计租面积不能为空',
      // 状态
      statusAvailable: '可用',
      statusRented: '已租',
      statusMaintenance: '维护中',
    },

    // ==================== 车位 ====================
    parking: {
      editTitle: '编辑车位',
      addTitle: '新增车位',
      code: '车位编码',
      name: '车位名称',
      type: '车位类型',
      area: '停车区域',
      rentableArea: '计租面积',
      section: '区域编号',
      monthlyFee: '月租金(元)',
      managementDept: '管理部门',
      managementDeptPlaceholder: '请选择管理部门',
      managementDeptRequired: '管理部门不能为空',
      codePlaceholder: '请输入车位编码',
      namePlaceholder: '请输入车位名称',
      typePlaceholder: '请选择车位类型',
      areaPlaceholder: '请输入停车区域',
      rentableAreaPlaceholder: '请输入计租面积',
      sectionPlaceholder: '请输入区域编号',
      monthlyFeePlaceholder: '请输入月租金',
      codeRequired: '请输入车位编码',
      typeRequired: '请选择车位类型',
      areaRequired: '停车区域不能为空',
      rentableAreaRequired: '计租面积不能为空',
      // 状态
      statusAvailable: '可用',
      statusRented: '已租',
      statusMaintenance: '维护中',
    },

    // ==================== 写字间 ====================
    officeSpace: {
      editTitle: '编辑写字间',
      addTitle: '新增写字间',
      code: '写字间编码',
      name: '写字间名称',
      type: '写字间类型',
      area: '建筑面积',
      rentableArea: '计租面积',
      standardRent: '标准租金',
      minRent: '最低租金',
      managementFee: '物业费',
      managementDept: '管理部门',
      managementDeptPlaceholder: '请选择管理部门',
      codePlaceholder: '请输入写字间编码',
      namePlaceholder: '请输入写字间名称',
      typePlaceholder: '请选择写字间类型',
      areaPlaceholder: '请输入建筑面积',
      rentableAreaPlaceholder: '请输入计租面积',
      rentPlaceholder: '请输入金额',
      feePlaceholder: '请输入物业费',
      codeRequired: '请输入写字间编码',
      nameRequired: '请输入写字间名称',
      typeRequired: '请选择写字间类型',
      areaRequired: '建筑面积不能为空',
      rentableAreaRequired: '计租面积不能为空',
      statusAvailable: '可用',
      statusRented: '已租',
      statusMaintenance: '维护中',
    },

    // ==================== 建筑物 ====================
    building: {
      title: '建筑物',
      editTitle: '编辑建筑物',
      addTitle: '新增建筑物',
      name: '建筑物名称',
      code: '建筑物编码',
      type: '建筑物类型',
      floorCount: '楼层数',
      totalArea: '建筑面积',
      constructionYear: '建造年份',
      structureType: '结构类型',
      namePlaceholder: '请输入建筑物名称',
      codePlaceholder: '请输入建筑物编码',
      typePlaceholder: '请选择建筑物类型',
      yearPlaceholder: '选择年份',
      structurePlaceholder: '请输入结构类型',
      floorCountPlaceholder: '请输入楼层数',
      totalAreaPlaceholder: '请输入建筑面积',
      sortOrderPlaceholder: '请输入排序值',
      nameRequired: '建筑物名称不能为空',
      orgRequired: '请选择所属组织',
      codeRequired: '建筑物编码不能为空',
      typeRequired: '建筑物类型不能为空',
      floorCountRequired: '楼层数不能为空',
      totalAreaRequired: '建筑面积不能为空',
      searchPlaceholder: '搜索建筑物...',
      noBuildings: '暂无建筑物',
      floorUnit: '{count}层',
      // 类型
      typeMall: '商场',
      typeOffice: '写字楼',
      typeResidential: '住宅',
      typeHotel: '酒店',
      typeOther: '其他',
      codeAutoGenerated: '(自动生成)',
    },

    // ==================== 楼层 ====================
    floor: {
      title: '楼层',
      noFloors: '暂无楼层',
      addFloor: '新增楼层',
      editTitle: '编辑楼层',
      addTitle: '新增楼层',
      name: '楼层名称',
      code: '楼层编码',
      floorNumber: '楼层号',
      totalArea: '建筑面积',
      rentableArea: '计租面积',
      mainBusinessType: '主要业态',
      namePlaceholder: '请输入楼层名称',
      codePlaceholder: '请输入楼层编码',
      businessTypePlaceholder: '请选择主要业态',
      floorNumberPlaceholder: '请输入楼层号',
      totalAreaPlaceholder: '请输入建筑面积',
      rentableAreaPlaceholder: '请输入计租面积',
      sortOrderPlaceholder: '请输入排序值',
      fromPlaceholder: '起始楼层',
      toPlaceholder: '结束楼层',
      nameRequired: '楼层名称不能为空',
      codeRequired: '楼层编码不能为空',
      floorNumberRequired: '楼层号不能为空',
      totalAreaRequired: '建筑面积不能为空',
      rentableAreaRequired: '计租面积不能为空',
      statusEnabled: '启用',
      statusDisabled: '停用',
      rentableSuffix: '可租',
      loadFailed: '加载楼层失败',
      codeAutoGenerated: '(自动生成)',
      // 业态类型
      businessRetail: '零售',
      businessFood: '餐饮',
      businessEntertainment: '娱乐',
      businessService: '服务',
      businessMixed: '综合',
      // 批量创建
      floorRange: '楼层范围',
      from: '从',
      to: '至',
      willCreate: '将创建',
      layers: '层',
      layer: '层',
      namePrefix: '名称前缀',
      namePrefixPlaceholder: '如：主力店（楼层号会自动追加到末尾）',
      namePrefixHint: '留空则使用默认命名规则：楼层号+层',
      codeAutoGeneratedTip: '系统自动生成',
      skipAndContinue: '跳过并继续',
      batchCreateSuccess: '成功创建 {count} 个楼层',
      batchCreatePartialSuccess: '成功 {success} 个，失败 {fail} 个',
      allFloorsExist: '所选楼层号均已存在，无需创建',
      existingFloorsConfirm: '楼层号 {floors} 已存在，是否跳过这些楼层并继续创建其余楼层？',
    },

    // ==================== 铺位 ====================
    shop: {
      title: '铺位',
      editTitle: '编辑铺位',
      addTitle: '新增铺位',
      name: '资产名称',
      code: '铺位编码',
      type: '铺位类型',
      area: '建筑面积',
      rentableArea: '计租面积',
      minRent: '最低租金',
      standardRent: '标准租金',
      managementFee: '物业费',
      position: '位置描述',
      plannedBusiness: '规划业态',
      namePlaceholder: '请输入资产名称',
      codePlaceholder: '请输入铺位编码',
      typePlaceholder: '请选择铺位类型',
      positionPlaceholder: '请输入位置描述或坐标JSON',
      plannedBusinessPlaceholder: '请输入规划业态',
      managementDept: '管理部门',
      managementDeptPlaceholder: '请选择管理部门',
      managementDeptRequired: '管理部门不能为空',
      sortOrderPlaceholder: '请输入排序值',
      nameRequired: '资产名称不能为空',
      codeRequired: '铺位编码不能为空',
      typeRequired: '铺位类型不能为空',
      areaRequired: '建筑面积不能为空',
      rentableAreaRequired: '计租面积不能为空',
      rentableAreaPlaceholder: '请输入计租面积',
      addShop: '新增铺位',
      // 视图
      visualView: '图形视图',
      listView: '列表视图',
      // 统计
      statTotal: '总计',
      statAvailable: '可租',
      statRented: '已租',
      statMaintenance: '维修中',
      statReserved: '预留',
      noShops: '暂无资产数据',
      // 类型
      typeRetail: '零售',
      typeFood: '餐饮',
      typeEntertainment: '娱乐',
      typeService: '服务',
      // 状态
      statusAvailable: '可租',
      statusRented: '已租',
      statusMaintenance: '维修中',
      statusReserved: '预留',
    },

    // ==================== 资产表格 ====================
    table: {
      searchPlaceholder: '搜索编码或名称',
      typeFilter: '资产类型',
      statusFilter: '状态',
      columnType: '类型',
      columnCode: '编码',
      columnName: '名称',
      columnManagementDept: '管理部门',
      columnArea: '建筑面积',
      columnRentableArea: '计租面积',
      columnStatus: '状态',
      columnOperation: '操作',
      noData: '暂无资产数据',
    },

    // ==================== 管理面板 ====================
    manage: {
      title: '资产管理',
      subtitle: '建筑物 · 楼层 · 多类型资产统一管理',
      visualView: '可视化',
      listView: '列表',
      totalAssets: '总资产',
      addAsset: '新增资产',
      selectFloorFirst: '请先选择楼层',
      selectBuildingFirst: '请先选择建筑物',
      selectBuildingPlaceholder: '请选择建筑物',
      loadFailed: '加载资产数据失败',
      deleteFailed: '删除失败',
      deleteAssetConfirm: '确认删除{type}"{name}"？',
      deleteBuildingConfirm: '确认删除建筑物"{name}"？删除后将同时删除关联的所有楼层和铺位。',
      deleteFloorConfirm: '确认删除楼层"{name}"？删除后将同时删除关联的所有铺位。',
      svgNoShapes: 'SVG中未识别到有效形状',
      pngNoRegions: '图片中未识别到彩色铺位区域，已作为普通底图导入',
      pngParseFail: '图片识别失败',
      svgSlimmed: '已自动优化大图：剥离 {removed} 条装饰线条（{fromMB}MB → {toMB}MB），如需保留完整纹理请导出PNG底图',
      svgClearedCount: '已清除楼层原有 {count} 个资产',
      svgImportSuccess: '导入成功：创建 {success} 个资产',
      bgImportSuccess: '底图导入成功',
      svgImportFailed: '，{fail} 个失败',
      svgImporting: '正在导入资产，请稍候...',
      svgBatchFailed: '批量创建失败',
      svgImportError: '导入失败: {msg}',
      svgImportTimeout: '资产创建请求已发送，可能需要等待处理完成，请稍后刷新查看结果',
      refreshFailed: '刷新资产数据失败',
      assetTypeShop: '铺位',
      assetTypeAdvertising: '广告位',
      assetTypeSharedSpace: '共享空间',
      assetTypeWarehouse: '仓库',
      assetTypeParking: '车位',
      assetTypeOfficeSpace: '写字间',
    },

    // ==================== 可视化面板 ====================
    visualPanel: {
      title: '资产可视化',
      floorSelected: '已选择楼层',
    },

    // ==================== 档案/广告位列表 ====================
    archive: {
      title: '资产档案',
      developing: '资产档案功能开发中...',
    },
    advertisingList: {
      title: '广告位管理',
      developing: '广告位管理功能开发中...',
    },

    // ==================== 建筑物列表 ====================
    buildingList: {
      keyword: '关键字',
      keywordPlaceholder: '请输入建筑物名称/编码/地址',
      addBuilding: '添加建筑物',
      editBuilding: '修改建筑物',
      buildingDetail: '建筑物详情',
      deleteConfirm: '是否确认删除建筑物编号为"{ids}"的数据项？',
      enableSuccess: '启用成功',
      disableSuccess: '禁用成功',
      addSuccess: '新增成功',
      editSuccess: '修改成功',
      enable: '启用',
      disable: '禁用',
      sortOrder: '显示排序',
      remarkLabel: '备注',
      remarkPlaceholder: '请输入内容',
      address: '地址',
      statusLabel: '状态',
      createTime: '创建时间',
      updateTime: '更新时间',
    },

    // ==================== 通用表单 ====================
    form: {
      statusRequired: '请选择状态',
      statusPlaceholder: '请选择状态',
      remarkPlaceholder: '请输入备注',
      addressPlaceholder: '请输入地址',
      codeExists: '该编码已存在，请使用其他编码',
      loadFailed: '加载数据失败',
      updateSuccess: '更新成功',
      createSuccess: '创建成功',
    },

    // ==================== 拆分合并 ====================
    splitMerge: {
      splitOrder: '拆分单',
      mergeOrder: '合并单',
      splitOrders: '拆分单列表',
      mergeOrders: '合并单列表',
      createSplit: '创建拆分单',
      createMerge: '创建合并单',
      orderNo: '单据编号',
      sourceAsset: '源资产',
      targetAsset: '目标资产',
      effectiveDate: '生效日期',
      splitCount: '拆分数量',
      sourceCount: '合并数量',
      splitMethod: '拆分方式',
      reason: '原因',
      isAdjacent: '是否相邻',
      adjacent: '相邻',
      notAdjacent: '非相邻',
      newCode: '新编码',
      newName: '新名称',
      newArea: '新面积',
      targetCode: '合并后编码',
      targetName: '合并后名称',
      targetArea: '合并后面积',
      status: {
        DRAFT: '草稿',
        PENDING: '待审核',
        APPROVED: '已通过',
        EFFECTIVE: '已生效',
        CANCELLED: '已取消',
      },
      actions: {
        submit: '提交审核',
        approve: '审核通过',
        reject: '驳回',
        cancel: '取消',
        split: '拆分',
        merge: '合并',
        lineage: '溯源',
      },
      contextMenu: {
        split: '拆分此资产',
        merge: '合并选中资产',
        lineage: '查看溯源',
        reOutline: '重新描边位置',
      },
      lineage: {
        title: '资产溯源',
        parent: '来源',
        child: '去向',
        noData: '暂无溯源记录',
      },
      visual: '可视化',
      form: '表单',
      areaExceeded: '面积超出源资产',
      areaMismatch: '拆分面积之和与源资产面积不一致',
      splitCreatedAndSubmitted: '拆分单已创建并提交审核，审核通过后将生效',
      splitExecuted: '拆分已执行，原资产已归档，新资产已生成',
    },

    // ==================== 资产调整 ====================
    adjustment: {
      title: '资产调整',
      adjustType: '调整类型',
      split: '拆分',
      merge: '合并',
      all: '全部',
      orderNo: '单号',
      sourceInfo: '源资产',
      effectiveDate: '生效日期',
      reason: '原因',
      status: '状态',
      createTime: '创建时间',
      createBy: '创建人',
      operation: '操作',
      addSplit: '新增拆分',
      addMerge: '新增合并',
      batchDelete: '批量删除',
      backToList: '返回列表',
      save: '保存',
      submit: '提交审核',
      approve: '审核通过',
      reject: '驳回',
      cancel: '取消',
      view: '查看',
      edit: '编辑',
      delete: '删除',
      newRecord: '新建',
      sourceAssetType: '源资产类型',
      sourceAssetId: '源资产ID',
      buildingId: '建筑',
      floorId: '楼层',
      splitMethod: '拆分方式',
      visual: '可视化',
      form: '表单',
      splitItems: '拆分明细',
      addItem: '新增行',
      removeItem: '删除',
      newCode: '新编码',
      newName: '新名称',
      newArea: '新面积',
      areaSummary: '面积合计',
      areaUnit: '㎡',
      areaExceeded: '面积超出源资产',
      sourceAssets: '源资产列表',
      addAsset: '添加资产',
      isAdjacent: '是否相邻',
      adjacent: '相邻',
      notAdjacent: '非相邻',
      targetCode: '合并后编码',
      targetName: '合并后名称',
      targetArea: '合并后面积',
      targetAsset: '目标资产',
      otherInfo: '其他信息',
      filterBuilding: '楼栋',
      filterFloor: '楼层',
      filterDateRange: '日期范围',
      search: '搜索',
      reset: '重置',
      noData: '暂无数据',
      confirmDelete: '确定删除该记录？',
      confirmCancel: '确定取消该记录？',
      rejectReason: '驳回原因',
      approveSuccess: '审批通过成功',
      rejectSuccess: '驳回成功',
      cancelSuccess: '取消成功',
      deleteSuccess: '删除成功',
      saveSuccess: '保存成功',
      submitSuccess: '提交审核成功',
      assetHasPendingOrders: '该资产已有未完成的拆分/合并单',
      statusDraft: '草稿',
      statusPending: '待审核',
      statusApproved: '已通过',
      statusEffective: '已生效',
      statusCancelled: '已取消',
    },
  },
}
